<template>
  <v-row>
    <v-col
      cols="12"
      md="8"
    >
      <template>
        <v-card outlined>
          <v-card-text>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Returned Item
                    </th>
                    <th class="text-left">
                      SKU
                    </th>
                    <th class="text-left">
                      Returned Qty
                    </th>
                    <th class="text-left">
                      Unit Price
                    </th>
                    <th class="text-left">
                      Reversed Discount
                    </th>
                    <th class="text-left">
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in items"
                    :key="item.name"
                  >
                    <td>{{ item.name }}</td>
                    <td>{{ item.sku }}</td>
                    <td>{{ item.qty }}</td>
                    <td>{{ item.price | currency }}</td>
                    <td>{{ item.discount }}%</td>
                    <td>{{ item.subTotal | currency }}</td>
                  </tr>
                  <tr>
                    <th
                      class="text-right"
                      colspan="5"
                    >
                      Grand Total ({{ order.totalItems }} items) :
                      {{ order.subTotal | currency }}
                    </th>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </template>
      <template>
        <payments-list :order-id="$route.params.id" />
      </template>
      <template v-if="order.shippingRecipient">
        <v-card
          outlined
          class="mt-3"
        >
          <v-card-text>
            <div><v-icon>mdi-truck-fast</v-icon> Shipping Info</div>
            <v-simple-table
              dense
              class="mt-3"
            >
              <template v-slot:default>
                <tbody>
                  <tr>
                    <th class="text-left">
                      Shipping Status
                    </th>
                    <td>
                      <template v-if="order.shippingStatus">
                        <v-icon
                          class="success--text"
                          small
                        >
                          mdi-check-circle
                        </v-icon>Sent
                      </template>
                      <template v-else>
                        <v-icon
                          class="red--text"
                          small
                        >
                          mdi-block-helper
                        </v-icon>
                        Pending

                        <v-icon
                          info
                          @click="shipped"
                        >
                          mdi-telegram
                        </v-icon>
                      </template>
                    </td>
                  </tr>
                  <tr>
                    <th class="text-left">
                      Shipping Amount
                    </th>
                    <td>{{ order.shippingAmount | currency }}</td>
                  </tr>
                  <tr>
                    <th>Recipient</th>
                    <td>{{ order.shippingRecipient }}</td>
                  </tr>
                  <tr>
                    <th>Location</th>
                    <td>{{ order.shippingInfo }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </template>
    </v-col>
    <v-col
      cols="12"
      md="4"
    >
      <v-card outlined>
        <v-card-text>
          <v-btn
            class="ml-3"
            small
            @click="$router.back()"
          >
            Back
          </v-btn>
          <v-simple-table
            dense
            class="red--text"
          >
            <template v-slot:default>
              <tbody>
                <tr>
                  <th class="text-left">
                    Refund TRX #
                  </th>
                  <td>
                    {{ order.key }}
                    <v-icon
                      small
                      @click="
                        $router.push({
                          name: 'SaleDetail',
                          params: { id: order.parent_id },
                        })
                      "
                    >
                      mdi-link
                    </v-icon>
                  </td>
                </tr>
                <tr class="active white">
                  <td colspan="2">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-img
                          v-bind="attrs"
                          :src="order.barcode"
                          lazy-src="/storage/default_img/no_image.png"
                          aspect-ratio="1"
                          max-width="200"
                          max-height="25"
                          v-on="on"
                        />
                      </template>
                      <span>Trx #{{ order.key }}</span>
                    </v-tooltip>
                  </td>
                </tr>
                <tr>
                  <th class="text-left">
                    Created At
                  </th>
                  <td>{{ order.created_at }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
      <v-card
        outlined
        class="mt-3"
      >
        <v-card-text>
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr>
                  <th>Reversed Discount {{ order.discountRate }}%</th>
                  <td>- {{ order.discountedAmount | currency }}</td>
                </tr>
                <tr>
                  <th>Tax Fall {{ order.taxRate }}%</th>
                  <td>+ {{ order.taxAmount | currency }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
      <v-card
        outlined
        class="mt-3"
      >
        <v-card-text>
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr>
                  <th class="text-left">
                    Net Sale Cost
                  </th>
                  <td>{{ order.cost | currency }}</td>
                </tr>
                <tr>
                  <th>Net Sale Price</th>
                  <td>{{ order.price | currency }}</td>
                </tr>
                <tr class="active">
                  <th>Net Sale Profit</th>
                  <td>{{ order.profit | currency }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import PaymentsComponent from "../common/Payments.vue";
import { mapActions } from "vuex";
export default {
  components: {
    "payments-list": PaymentsComponent,
  },
  data() {
    return {
      sale: {},
      items: {},
      order: {},
    };
  },
  mounted() {
    this.getFromApi();
  },
  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),
    shipped() {
      window.axios
        .post("/order-shipped/" + this.$route.params.id)
        .then((response) => {
          this.feedback(response.data.message);
          this.$data.order.shippingStatus = true;
        });
    },
    getFromApi() {
      window.axios.get("/order/" + this.$route.params.id).then((response) => {
        this.$data.sale = response.data.order;
        this.$data.items = response.data.order.items;
        this.$data.order = response.data.order;
      });
    },
  },
};
</script>
